<template>
	<div class="page-layout">
		<div class="header">
			<div v-if="root" style="position: relative;">
				<img class="icon" @click.stop="function () { $store.commit('navigation', { active: true }) }" src="/images/icons/menu.svg" />
				<div class="highlight" v-if="_highlight > 0">{{ _highlight }}</div>
			</div>
			<div v-else>
				<img class="icon" @click.stop="function () { $router.go(-1) }" src="/images/icons/arrow-left.svg" />
			</div>
			<div class="title">{{ title }}{{ gps }}</div>
			<div class="user">
				<img class="icon" @click.stop="userIconClick" src="/images/icons/user.svg" />
				<div class="status" :style="{
					backgroundColor: _pause ? '#ffcf00' : (_checkedIn ? '#00c017' : '#f7223f')
				}"></div>
			</div>
		</div>
		<slot class="content" />
	</div>
</template>

<script>
	import SelectPopupView from '@/components/SelectPopupView';
	import FormPopupView from '@/components/FormPopupView';

	export default {
		data() {
			return {
				gps: ''
			};
		},
		props: {
			title: {
				type: String,
				required: true
			},
			root: {
				type: Boolean,
				default: true
			}
		},
		computed: {
			_checkedIn() {
				return this.$store.getters.stamps.find(function (stamp) { return stamp.type == 'in' && stamp.task_id === null; });
			},
			_pause() {
				return this.$store.getters.stamps.find(function (stamp) { return stamp.type == 'pause' && stamp.task_id === null; });
			},
			_highlight() {
				const unreadNews = this.$store.getters.unreadNews.length;

				return unreadNews;
			},
		},
		methods: {
			userIconClick() {
				var self = this;

				var checkAction = this._checkedIn ? {
					label: 'Stempel ud',
					callback() {
						
						self.axios.post('/me/stamps/', {
							lat: 0,
							lng: 0,
							type: 'out'
						}).then(function (r) {
							self.axios.get('/me/stamps/active/').then(function (r) {
								console.log(r.data);
								self.$store.commit('stamps', r.data);
							});

							// IN
							const checkout = (token) => {
								const msg = {
									call: 'logout',
									token: token
								};

								if (window.webkit != undefined) {
									if (window.webkit.messageHandlers.appInterface != undefined) {
										window.webkit.messageHandlers.appInterface.postMessage(msg);
									}
								}
								if (window.appInterface != undefined) {
									window.appInterface.postMessage(msg);
								}
							};

							checkout(self.$store.getters.auth);
						});

						/*
						function success(position) {
							const lat  = position.coords.latitude;
							const lng = position.coords.longitude;

							self.axios.post('/me/stamps/', {
								lat: lat,
								lng: lng,
								type: 'out'
							}).then(function (r) {
								self.axios.get('/me/stamps/active/').then(function (r) {
									console.log(r.data);
									self.$store.commit('stamps', r.data);
								});

								// IN
								const checkout = (token) => {
									const msg = {
										call: 'logout',
										token: token
									};

									if (window.webkit != undefined) {
										if (window.webkit.messageHandlers.appInterface != undefined) {
											window.webkit.messageHandlers.appInterface.postMessage(msg);
										}
									}
									if (window.appInterface != undefined) {
										window.appInterface.postMessage(msg);
									}
								};

								checkout(self.$store.getters.auth);
							});
						}

						function error() {
							//self.gps = 'Unable to retrieve your location';
							alert('Kunne ikke checke ind, mangler lokation.');
						}

						if (!navigator.geolocation) {
							//self.gps = 'Geolocation is not supported by your browser';
						} else {
							//self.gps = 'Locating…';
							navigator.geolocation.getCurrentPosition(success, error);
						}
							*/

						self.$store.commit('clearPopup');
					}
				} : {
					label: 'Stempel ind',
					callback() {
						//const status = document.querySelector('#status');
						//const mapLink = document.querySelector('#map-link');

						//mapLink.href = '';
						//mapLink.textContent = '';

						self.axios.post('/me/stamps/', {
							lat: 0,
							lng: 0,
							type: 'in'
						}).then(function (r) {
							self.axios.get('/me/stamps/active/').then(function (r) {
								console.log(r.data);
								self.$store.commit('stamps', r.data);
							});

							// IN
							const checkin = (token) => {
								const msg = {
									call: 'login',
									token: token
								};

								if (window.webkit != undefined) {
									if (window.webkit.messageHandlers.appInterface != undefined) {
										window.webkit.messageHandlers.appInterface.postMessage(msg);
									}
								}
								if (window.appInterface != undefined) {
									window.appInterface.postMessage(msg);
								}
							};

							checkin(self.$store.getters.auth);
						});
						/*
						function success(position) {
							const lat  = position.coords.latitude;
							const lng = position.coords.longitude;

							self.axios.post('/me/stamps/', {
								lat: lat,
								lng: lng,
								type: 'in'
							}).then(function (r) {
								self.axios.get('/me/stamps/active/').then(function (r) {
									console.log(r.data);
									self.$store.commit('stamps', r.data);
								});

								// IN
								const checkin = (token) => {
									const msg = {
										call: 'login',
										token: token
									};

									if (window.webkit != undefined) {
										if (window.webkit.messageHandlers.appInterface != undefined) {
											window.webkit.messageHandlers.appInterface.postMessage(msg);
										}
									}
									if (window.appInterface != undefined) {
										window.appInterface.postMessage(msg);
									}
								};

								checkin(self.$store.getters.auth);
							});
						}

						function error() {
							//self.gps = 'Unable to retrieve your location';
							//window.location = 'alert:Kunne ikke checke ind, mangler lokation.';
							alert('Kunne ikke checke ind, mangler lokation.');
						}

						if (!navigator.geolocation) {
							//self.gps = 'Geolocation is not supported by your browser';
						} else {
							//self.gps = 'Locating…';
							navigator.geolocation.getCurrentPosition(success, error);
						}
							*/

						//self.$store.commit('workCheckIn');
						self.$store.commit('clearPopup');
					}
				};

				var pauseAction = this._pause ? {
					label: 'Genoptag',
					callback() {
						self.axios.post('/me/stamps/', {
							lat: 0,
							lng: 0,
							type: 'resume'
						}).then(function (r) {
							self.axios.get('/me/stamps/active/').then(function (r) {
								console.log(r.data);
								self.$store.commit('stamps', r.data);
							});
						});

						/*function success(position) {
							const lat  = position.coords.latitude;
							const lng = position.coords.longitude;

							self.axios.post('/me/stamps/', {
								lat: lat,
								lng: lng,
								type: 'resume'
							}).then(function (r) {
								self.axios.get('/me/stamps/active/').then(function (r) {
									console.log(r.data);
									self.$store.commit('stamps', r.data);
								});
							});
						}

						function error() {
							//self.gps = 'Unable to retrieve your location';
							//window.location = 'alert:Kunne ikke checke ind, mangler lokation.';
							alert('Kunne ikke checke ind, mangler lokation.');
						}

						if (!navigator.geolocation) {
							//self.gps = 'Geolocation is not supported by your browser';
						} else {
							//self.gps = 'Locating…';
							navigator.geolocation.getCurrentPosition(success, error);
						}*/

						self.$store.commit('clearPopup');
					}
				} : {
					label: 'Pause',
					callback() {
						//const status = document.querySelector('#status');
						//const mapLink = document.querySelector('#map-link');

						//mapLink.href = '';
						//mapLink.textContent = '';

						self.axios.post('/me/stamps/', {
							lat: 0,
							lng: 0,
							type: 'pause'
						}).then(function (r) {
							self.axios.get('/me/stamps/active/').then(function (r) {
								console.log(r.data);
								self.$store.commit('stamps', r.data);
							});
						});

						/*
						function success(position) {
							const lat  = position.coords.latitude;
							const lng = position.coords.longitude;

							self.axios.post('/me/stamps/', {
								lat: lat,
								lng: lng,
								type: 'pause'
							}).then(function (r) {
								self.axios.get('/me/stamps/active/').then(function (r) {
									console.log(r.data);
									self.$store.commit('stamps', r.data);
								});
							});
						}

						function error() {
							//self.gps = 'Unable to retrieve your location';
							//window.location = 'alert:Kunne ikke checke ind, mangler lokation.';
							alert('Kunne ikke checke ind, mangler lokation.');
						}

						if (!navigator.geolocation) {
							//self.gps = 'Geolocation is not supported by your browser';
						} else {
							//self.gps = 'Locating…';
							navigator.geolocation.getCurrentPosition(success, error);
						}*/

						//self.$store.commit('workCheckIn');
						self.$store.commit('clearPopup');
					}
				};

				var opts = [checkAction];

				if (this._checkedIn) {
					opts.push(pauseAction);
				}

				opts.push({
						label: 'Ansøg om ferie / fri',
						callback() {
							console.log('Ferie fri');

							var leaveOpts = [];
							var leaveTypes = [
								{
									label: 'Fri',
									id: 11
								},
								{
									label: 'Ferie',
									id: 5
								}
							];	
							
							for (var i = 0; i < leaveTypes.length; ++i) {
								var lt = leaveTypes[i];

								leaveOpts.push({
									label: lt.label,
									callback: function () {
										var lbl = lt.label;
										var id = lt.id;

										return function () {
											var form = [
												{
													label: 'Fra',
													value: new Date(),
													name: 'from',
													type: 'date'
												},
												{
													label: 'Til',
													value: new Date(),
													name: 'to',
													type: 'date'
												}
											];
											
											self.$store.commit('pushPopup', {
												component: FormPopupView,
												props: {
													title: lbl,
													form: form,
													actions: [
														{
															label: 'Send',
															callback() {
																// Send here
																self.axios.post('/employees/me/leave/requests/', {
																	leave_type_id: id,
																	from: form[0].value,
																	to: form[1].value
																});

																self.$store.commit('clearPopup');
															}
														},
														{
															label: 'Annuller',
															callback() {
																self.$store.commit('popPopup');
															}
														}
													]
												}
											});
										};
									}()
								});
							}

							self.$store.commit('pushPopup', {
								component: SelectPopupView,
								props: {
									title: 'Ansøg om...',
									options: leaveOpts,
									actions: [
										{
											label: 'Annuller',
											callback() {
												self.$store.commit('popPopup');
											}
										}
									]
								}
							});
						}
					}
							/*{
								label: 'Meld fravær',
								callback() {
									console.log('fravær');
									//self.$store.commit('popPopup');

									self.$store.commit('pushPopup', {
										component: FormPopupView,
										props: {
											title: 'Meld fravær',
											form: [
												{
													label: 'Type',
													value: 'sickness',
													name: 'type',
													type: 'select',
													options: [
														{
															label: 'Sygdom',
															value: 'sickness'
														},
														{
															label: 'Sygt barn',
															value: 'child'
														}
													]
												},
												{
													label: 'Fra',
													value: new Date(),
													name: 'from',
													type: 'date'
												},
												{
													label: 'Til',
													value: new Date(),
													name: 'to',
													type: 'date'
												}
											],
											actions: [
												{
													label: 'Send',
													callback() {
														self.$store.commit('clearPopup');
													}
												},
												{
													label: 'Annuller',
													callback() {
														self.$store.commit('popPopup');
													}
												}
											]
										}
									});
								}
				},*/);

				opts.push({
					label: 'Log ud',
					callback() {
						//console.log('Log ud');
						self.$store.commit('popPopup');
						self.$store.commit('auth', null);
						self.$router.replace({
							name: 'login'
						});
					}
				});

				console.log(self.$store.state.user);

				this.$store.commit('pushPopup', {
					component: SelectPopupView,
					props: {
						title: self.$store.state.user.name,
						options: opts,
						actions: [
							{
								label: 'Annuller',
								callback() {
									self.$store.commit('popPopup');
								}
							}
						]
					}
				});
			}
		}
	}
</script>

<style lang="scss" scoped>
	.highlight {
		position: absolute;
		height: 26px;
		min-width: 26px;
		background-color: #f7223f;
		border-radius: 15px;
		top: -5px;
		right: -10px;
		color: white;
		line-height: 20px;
		padding: 0 5px 0 5px;
		border: 3px solid white;
		text-align: center;
	}

	.page-layout {
		background-color: white;
		display: grid;
		grid-template-rows: 50px 1fr;

		& > * {
			min-height: 0;
		}

		& > .header {
			position: relative;
			padding: 20px 20px 0 20px;
			display: grid;
			grid-template-columns: 30px 1fr 30px;			

			& > .title {
				height: 30px;
				line-height: 30px;
				font-size: 20px;
				padding-left: 20px;
			}

			& > .toolbar {
				height: 30px;
				position: absolute; 
				right: 20px;
				top: 20px;
			}

			& .icon {
				width: 30px;
				height: 30px;
				display: block;
			}

			& > .user {
				position: relative;

				& > .status {
					position: absolute;
					width: 16px;
					height: 16px;
					background-color: #00c017;
					border: 3px solid white;
					border-radius: 50%;
					top: -4px;
					right: -4px;
				}
			}
		}
	}
</style>